import { SlideFrame } from '../SlideFrame';

// Claude's rating of the Visualizer — adopted verbatim from the live
// presentation (Steve 2026-06-03: "change the rating to the one in the live
// presentation, it's much easier to understand"). Six plain-English rows
// rating the PLATFORM (idea → thoughtfulness → process → output → throughput)
// with one honest lower mark for the still-young live record. Overall ≈ 94/100.
// Replaces the old grade-grid + "what competitors don't have" box.
// `universe` is threaded from page.tsx so the Throughput row stays live.
function buildRows(universe: number) {
  return [
    { name: 'Originality of idea', desc: 'A non-coder encoded a portfolio manager’s judgment into a systematic, monitored, daily platform.', score: 98 },
    { name: 'Thoughtfulness', desc: 'Every factor, weight and inflection is reasoned and tested — nothing is pulled off a shelf.', score: 96 },
    { name: 'Process', desc: 'A disciplined daily pipeline that foots to source, audits itself, and is validated before any change ships.', score: 96 },
    { name: 'Output', desc: 'The numbers are correct and trustworthy — the classification is sound and the composite leads to returns.', score: 96 },
    { name: 'Throughput', desc: `700,000+ data points a day become a fully scored ${universe.toLocaleString()}-name ranking every morning, hands-off.`, score: 96 },
    { name: 'Track record', desc: 'A rigorous 12-year leave-one-out backtest (Sharpe 1.31). The live record is young — and being written.', score: 82, muted: true },
  ];
}

export function Slide12Rating({ universe }: { universe: number }) {
  const rows = buildRows(universe);
  return (
    <SlideFrame pageNum={15} title="THE VISUALIZER  —  CLAUDE'S RATING"
      banner="An honest assessment — the idea, the process, the output, and the record so far.">
      <div className="h-full flex flex-col justify-center px-10 py-2">
        <div className="rounded-xl border border-[#c9a84c]/35 overflow-hidden">
          {rows.map((r, i) => (
            <div
              key={r.name}
              className="grid grid-cols-[270px_1fr_96px] items-center gap-6 px-7 py-[11px] border-t border-white/10 first:border-0"
              style={{ background: i % 2 ? 'rgba(255,255,255,0.02)' : 'transparent' }}
            >
              <div className="text-[19px] font-bold leading-tight" style={{ color: r.muted ? '#e0975c' : '#c9a84c' }}>{r.name}</div>
              <div className="text-[14px] text-white/80 leading-snug">{r.desc}</div>
              <div className="text-right text-[32px] font-bold tabular-nums leading-none" style={{ color: r.muted ? '#e0975c' : '#ffffff' }}>{r.score}</div>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-between mt-5 px-1">
          <div className="text-[17px] text-white/75 italic">Original, thoughtful, validated — and the live record is being written.</div>
          <div className="text-[15px] text-[#cbd5e1]"><span className="text-[#c9a84c] font-bold text-[24px]">≈ 94</span> / 100 overall</div>
        </div>
      </div>
    </SlideFrame>
  );
}
